<template>
  <div class='approvalDetail' style='position: relative;'>
    <a-spin :spinning='loading'>
      <!--  客户影像资料    -->
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerImageInfo')"
        type='inner'
        v-viewer='viewOptions'>
        <div v-for='(item, index) in imageInfos' :key='item.imgType'>
          <div class='file-box'>
            <div class='file-item'>
              <p class='file-label'>{{ FILE_TYPE[item.imgType] }}</p>
              <img class='file-preview' :src='item.imgUrl' preview='0'>
            </div>
          </div>
        </div>
      </a-card>
      <!--  订单信息-->
      <a-card
        :title="$t(I18N_KEY.ORDER + 'orderInfo')"
        type='inner'
        style='margin-top: 24px;'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'productName')">{{ orderInfo.productName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applyAmt')">{{ orderInfo.applyAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'submissionTime')">{{ orderInfo.submitTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'applicationDeadline')">{{ orderInfo.applyDuration }}
          </detail-list-item>

          <detail-list-item :term="$t(I18N_KEY.ORDER + 'orderNo')">{{ orderInfo.orderNo }}</detail-list-item>
          <detail-list-item v-if="languageStorage=='zh-CN'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_CN[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='en-US'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_EN[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='ti'" :term="$t(I18N_KEY.ORDER + 'orderType')">
            {{ $t(ORDER_TYPE_TI[orderInfo.orderType]) }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentAmt')">{{ orderInfo.paymentAmt }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'paymentTime')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.paymentTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'extendAmoumt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.extendAmoumt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'repaymentAmount')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.repaymentAmount }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settleAmt')" v-if='orderInfo.settleStatus == 0'>
            {{ orderInfo.settleAmt }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'lateFee')">{{ orderInfo.lateFee }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'overdueDayC')">{{ orderInfo.overdueDays }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'OrdersubmissionTime')">{{ orderInfo.submitTime }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'payoutId')">{{ orderInfo.payoutId }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankName')">
            <Dict :dict-code='DICT_CODE.BANKLISTF' :value='bankCardInfo.bankAccountName' />
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
        </detail-list>
      </a-card>
      <!--审核客户信息-->
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.CUSTOMER + 'customerBasicInfo')"
        type='inner'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'names')">
            {{ basicInfo.names }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'ThaiName')">{{ basicInfo.surnames }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'ThaibmName')">{{ basicInfo.aliasName }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'curp')">{{ basicInfo.curp }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'birthdayValue')">{{ basicInfo.birthday }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'shouru')">{{ detailInfo.monthlyIncomeScope }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'educalevel')">{{ detailInfo.education }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'childNum')">{{ detailInfo.numberOfChildren }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'marryState')">{{ detailInfo.maritalStatus }}
          </detail-list-item>


          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'bankAccountNo')">{{ bankCardInfo.bankAccountNo }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'collectType')">{{ COLLECT_TYPE[bankCardInfo.collectType] }}
          </detail-list-item>

          <detail-list-item v-if="languageStorage=='zh-CN'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='en-US'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG_EN[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item v-if="languageStorage=='ti'" :term="$t(I18N_KEY.CUSTOMER + 'reborrowFlag')">
            {{ REBORROW_FLAG_TI[basicInfo.reborrowFlag] }}
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'createTime')">{{ basicInfo.createdTime }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'fb')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showFBInput'>
                <a-input v-model='FBvalue' />
              </div>
              <div v-else>
                <a :href='"https://www.facebook.com/"+detailInfo.fb' target='_blank'>
                  {{ detailInfo.fb }}
                </a>
              </div>
<!--              <a-button v-if='showFBInput' @click='saveFBEdit' type='primary'-->
<!--                        style='margin-left: 20px'>-->
<!--                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}-->
<!--              </a-button>-->

<!--              <a-button v-if='showFBInput' @click='cancelSaveFBEdit' type='primary'-->
<!--                        style='margin-left: 20px'>-->
<!--                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}-->
<!--              </a-button>-->

<!--              <a-button v-if='btndisableFBValue' @click='editFBEmail(detailInfo.fb,detailInfo.custInfoId)'-->
<!--                        type='primary'-->
<!--                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}-->
<!--              </a-button>-->
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.CUSTOMER + 'creatEmail')">
            <div style='display: flex;justify-content: flex-start;flex-direction: row'>
              <div v-if='showEmialInput'>
                <a-input v-model='emailvalue' />
              </div>
              <div v-else>
                {{ basicInfo.email }}
              </div>
<!--              <a-button v-if='showEmialInput' @click='saveEdit' type='primary'-->
<!--                        style='margin-left: 20px'>-->
<!--                {{ $t(I18N_KEY.ORDER + 'saveEdit') }}-->
<!--              </a-button>-->

<!--              <a-button v-if='showEmialInput' @click='cancelSaveEdit' type='primary'-->
<!--                        style='margin-left: 20px'>-->
<!--                {{ $t(I18N_KEY.ORDER + 'cancelSaveEdit') }}-->
<!--              </a-button>-->

<!--              <a-button v-if='btndisableEmailValue' @click='editEmail(basicInfo.email,basicInfo.id)'-->
<!--                        type='primary'-->
<!--                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'EditValue') }}-->
<!--              </a-button>-->
              <!--       发送邮件        -->
              <!--              <a-button @click='sendEmail(basicInfo.email,basicInfo.id)' type='primary'-->
              <!--                        style='margin-left: 20px'> {{ $t(I18N_KEY.ORDER + 'senfEmail') }}-->
              <!--              </a-button>-->
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'RegisPhoneNum')">
            <div style='display: flex;flex-direction: row'>
              <a :href="'sip:'+ basicInfo.mobileNo"
                 @click="handlePhoneClick('sip:'+ basicInfo.mobileNo)">
                <!--                {{ basicInfo.mobileNoASE }}</a>-->
                {{ basicInfo.mobileNo }}</a>
<!--              <a-button v-if='btndisableValue'-->
<!--                        @click='openRemarkModal("本人",basicInfo.names,basicInfo.mobileNo,4)'-->
<!--                        style='margin-left: 30px'-->
<!--                        type='primary'> {{ $t('remark') }}-->
<!--              </a-button>-->
<!--              <div style='margin-left: 20px' v-if='showzhudedianhua && btndisableValue'><img style='width: 28px'-->
<!--                                                                                             src='../../../assets/finish.png'>-->
<!--              </div>-->
            </div>
          </detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'line')">{{ detailInfo.line }}</detail-list-item>

        </detail-list>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'witnessScore')">{{ detailInfo.witnessScore }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card
        style='margin-top: 24px'
        :title="$t(I18N_KEY.ORDER + 'lastOrderInfo')"
        type='inner'>
        <detail-list>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'loanNumber')">{{ lastOrderInfo.loanCount }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settlementType')">{{ PAYTYPE[lastOrderInfo.orderType] }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settleAmt')">{{ lastOrderInfo.repayAmount }}</detail-list-item>
          <detail-list-item :term="$t(I18N_KEY.ORDER + 'settlementTime')">{{ lastOrderInfo.repayDate }}</detail-list-item>
        </detail-list>
      </a-card>
      <!--  客户联系人信息-->
      <a-card
        style='margin-top: 24px ;'
        :title="$t(I18N_KEY.CUSTOMER + 'customerLinkInfo')"
        type='inner'>
        <a-table
          :columns='linkColumns'
          :dataSource='linkmanInfos'
          :pagination='false'
          bordered
          ref='table'
          size='middle'
          :rowKey='(record) => record.index'>
          <template slot='contactPhonteValue' slot-scope='text, record,index'>
            <div
              style='display: flex;flex-direction: row;align-items: center;justify-content: center;'>
              <div style='width:200px;display: flex;justify-content: center'>
                <div>
                  <a :href="'sip:'+ record.contactPhone"
                     @click="handlePhoneClick('sip:'+ record.contactPhone)">
                    {{ record.contactPhone
                    }}</a>
                </div>
<!--                <div-->
<!--                  style='margin-left: 20px;'>-->
<!--                  <a-button type='primary' v-if='btndisableValue'-->
<!--                            @click='openRemarkModal(record.contactType,record.contactName,record.contactPhone,index)'>-->
<!--                    {{ $t('remark') }}-->
<!--                  </a-button>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <img v-if="record.backup!='' && btndisableValue" style='width: 28px;margin-left: 20px'-->
<!--                       src='../../../assets/finish.png'>-->
<!--                </div>-->
              </div>
            </div>
          </template>
          <template v-if="languageStorage=='ti' || languageStorage=='zh-CN' || languageStorage=='en-US'"
                    slot='contactType' slot-scope='text, record'>
  <span :value='text'>
    {{ languageStorage == 'ti' ? $t(ContactPerson_FLAG_TI[text]) : languageStorage == 'zh-CN' ? $t(ContactPerson_FLAG[text]) : $t(ContactPerson_FLAG_EN[text])
    }}
  </span>
          </template>

          <Dict slot='relationType' slot-scope='text' :dict-code='DICT_CODE.REALTIONSHIP' :value='text' />
        </a-table>
      </a-card>
      <a-card
        type='inner'>
        <a-tabs v-model='currentTab'>
          <!--  催收记录-->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'collectionRecord')" key='1' forceRender>
            <a-table
              :columns='examineColumns'
              :dataSource='examineSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'>
              <Dict slot='custContractCondition' slot-scope='text' :dict-code='DICT_CODE.CUST_CONTRACT_CONDITION'
                    :value='text' />
              <Dict slot='linkCondition' slot-scope='text' :dict-code='DICT_CODE.LINKCONDITION' :value='text' />
              <Dict slot='repaymentIntention' slot-scope='text' :dict-code='DICT_CODE.REAPYMENT_INTENTION'
                    :value='text' />
              <Dict slot='collectionTaskStatus' slot-scope='text' :dict-code='DICT_CODE.COLLECTION_TASK_STATUS'
                    :value='text' />
            </a-table>
          </a-tab-pane>
          <!--用户或最近联系人电话号码-->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'orderNumber')" key='2' forceRender>
            <a-table
              :columns='orderNumberColumns'
              :dataSource='orderNumberSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'>
            </a-table>
          </a-tab-pane>
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'addressBookList')" key='3'>
            <a-table
              :columns='addressBookColumns'
              :dataSource='addressBookSource'
              :pagination='addressBookIpagination'
              :loading='addressBookLoading'
              @change='handleTableChange'
              bordered
              ref='table'
              size='middle'>
            </a-table>
          </a-tab-pane>
          <!--还款记录-->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'repaymentRecord')" key='4'>
            <a-table
              :columns='repayRecordColumns'
              :dataSource='repayRecordSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'
              :rowKey='(record) => record.index'>
            </a-table>
          </a-tab-pane>
          <!--   审批记录    -->
          <a-tab-pane :tab="$t(I18N_KEY.ORDER + 'approvalRecord')" key='5' forceRender>
            <a-table
              :columns='ApprovalRecordColumn'
              :dataSource='ApprovalRecordSource'
              :pagination='false'
              bordered
              ref='table'
              size='middle'>
              <Dict slot='approveTaskStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_TASK_STATUS'
                    :value='text' />
              <Dict slot='approveStatus' slot-scope='text' :dict-code='DICT_CODE.APPROVAL_STATUS' :value='text' />
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-spin>

    <!--    非空校验弹框-->
    <a-modal v-model='ModalVisible' title='操作提醒' @ok='handleOk'>
      <p>有必填未填写！！</p>
    </a-modal>
  </div>

</template>
<script>
import { DetailList } from '@/components'
import { mapActions, mapGetters } from 'vuex'
import CryptoJS from 'crypto-js'

import {
  REBORROW_FLAG,
  REBORROW_FLAG_EN,
  REBORROW_FLAG_TI,
  SEX,
  CONTACT_TYPE,
  ORDER_TYPE_CN,
  CURP_TYPE,
  COLLECT_TYPE,
  ORDER_TYPE_EN, ORDER_TYPE_TI, ContactPerson_FLAG_TI, ContactPerson_FLAG_EN, ContactPerson_FLAG, PAYTYPE
} from '@/constants/status'
import Dict from '../modules/Dict'
import imageMixin from '@/mixins/image-mixin'
import { modExamineTaskUser, peopleExamine, sendEmailfn } from '@/webpublicapi/approval'
import { editCustomer, editFacebook } from '@/webpublicapi/customer'
import lang from '@/i18n/lang'
import i18n from '@/i18n'
import sendGroupList from '@/views/webpublic/operation/SendGroupList.vue'
// import HumanReviewDataSet from '../src/i18n/lang/modules/HumanReviewDataSet'


const DetailListItem = DetailList.Item

const I18N_KEY = {
  CUSTOMER: 'customer.',
  ORDER: 'order.',
  APPROVAL: 'approval.',
  HumanReviewDataSet: 'HumanReviewDataSet.'
}

export default {
  props: {
    orderId: {
      type: [String, Number],
      default: undefined
    },
    custInfoId: {
      type: [String, Number],
      default: undefined
    },
    taskId: {
      type: [String, Number],
      default: undefined
    },
    auditDrawer: {
      type: Boolean,
      default: false
    },
    approvalStatus: {
      type: [String, Number],
      default: undefined
    }
  },
  components: {
    DetailList,
    DetailListItem,
    Dict
  },
  mixins: [imageMixin],
  data() {
    return {
      normremarkChecked: false,
      normRemark: true,
      remarkOptions: [],
      disableRemark: false,
      btndisableFBValue: true,//编辑fb
      btndisableEmailValue: true,//编辑email
      btndisableValue: false,
      showzhudedianhua: false,
      showFinishImg: 0,
      //选项数据回显
      selectedOptionsOne: [],
      selectedOptionsTwo: [],
      selectedOptionsThree: [],
      selectedOptionsFour: [],
      normOne: true,
      normTwo: true,
      normThree: true,
      normFour: true,
      ContactVisible: false,
      ContactconfirmLoading: false,
      showEmialInput: false,
      emailvalue: '.com',
      emailEditID: '',
      showFBInput: false,
      FBvalue: '.com',
      FBEditID: '',
      lang,
      i18n,
      remarkValue: '',//备注栏的默认内容
      bigRemarkValue: '',
      phoneRemarkValue: '',//电话备注栏的默认内容
      ModalVisible: false,//校验提示弹框
      //存储四个正常按钮的变量
      Q_cust_image_normal: false,
      Q_cust_living_body_normal: false,
      Q_cust_contactperson_normal: false,
      Q_contact_phone_normal: false,
      //非正常情况下多选的选项的数组
      image_normal_array: [],
      living_body_normal_array: [],
      contactperson_normal_array: [],
      ontact_phone_array: [],
      //是否禁用
      disable0ne: false,
      disableTwo: false,
      disableThree: false,
      disableFour: false,
      //子选项禁用时候的保留值
      childValueOne: [],
      childValueTwo: [],
      childValueThree: [],
      childValueFour: [],
      //存储刚才打开的联系人是谁
      contactWhoName: '',
      contactWhoPhone: '',
      contactWhoType: '',
      //传给后端的item
      chooseItems: [
        {
          'itemCode': 'Q_cust_image_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_living_body_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_cust_contactperson_normal',
          'itemResult': []
        },
        {
          'itemCode': 'Q_contact_phone_normal',
          'itemResult': []
        }
      ],
      I18N_KEY,
      REBORROW_FLAG,
      REBORROW_FLAG_EN,
      REBORROW_FLAG_TI,
      ORDER_TYPE_CN,
      ORDER_TYPE_EN,
      ORDER_TYPE_TI,
      SEX,
      CONTACT_TYPE,
      ContactPerson_FLAG_TI,
      ContactPerson_FLAG_EN,
      ContactPerson_FLAG,
      COLLECT_TYPE,
      PAYTYPE,
      visible: false,
      loading: true,
      confirmLoading: false,
      basicForm: this.$form.createForm(this),
      listItem: {},
      openDrawerCount: 0,
      currentTab: '1',
      linkColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactType'),
          dataIndex: 'contactType',
          key: 'contactType',
          align: 'center',
          scopedSlots: { customRender: 'contactType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactRelationship'),
          dataIndex: 'relationType',
          key: 'relationType',
          align: 'center',
          scopedSlots: { customRender: 'relationType' }
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactName'),
          dataIndex: 'contactName',
          key: 'contactName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactPhone'),
          dataIndex: 'contactPhone',
          key: 'contactPhone',
          align: 'center',
          width: '300px',
          scopedSlots: { customRender: 'contactPhonteValue' }
        }
      ],

      ApprovalRecordColumn: [
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStaff'),
          dataIndex: 'examineUserName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTime'),
          dataIndex: 'examineTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalTaskStatus'),
          dataIndex: 'approveTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveTaskStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalStatus'),
          dataIndex: 'approveStatus',
          align: 'center',
          scopedSlots: { customRender: 'approveStatus' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'approvalRemark'),
          dataIndex: 'comment',
          align: 'center'
        }
      ],
      examineColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'overdueDay'),
          dataIndex: 'overdueDay',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'followResult'),
          dataIndex: 'followResult',
          align: 'center',
          scopedSlots: { customRender: 'custContractCondition' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'linkCondition'),
          dataIndex: 'contactsSituation',
          align: 'center',
          scopedSlots: { customRender: 'linkCondition' }
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionRemark'),
          dataIndex: 'remark',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'followUserName'),
          dataIndex: 'followUserName',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'followTime'),
          dataIndex: 'followTime',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'collectionTaskStatus'),
          dataIndex: 'collectionTaskStatus',
          align: 'center',
          scopedSlots: { customRender: 'collectionTaskStatus' }
        }
      ],
      orderNumberColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'mobile'),
          dataIndex: 'phoneNo',
          align: 'center'
        }
      ],
      addressBookLoading: false,
      addressBookColumns: [
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactName'),
          dataIndex: 'name',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.CUSTOMER + 'contactPhone'),
          dataIndex: 'phoneNo',
          align: 'center'
        }
      ],
      addressBookSource: [],
      // 通讯录分页参数
      addressBookIpagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      repayRecordColumns: [
        {
          title: this.$t(I18N_KEY.ORDER + 'payOrderNo'),
          dataIndex: 'payOrderNo',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payType'),
          dataIndex: 'payType',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payAmount'),
          dataIndex: 'payAmount',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'payRecipt'),
          dataIndex: 'payRecipt',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'description'),
          dataIndex: 'description',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'errorDescription'),
          dataIndex: 'errorDescription',
          align: 'center'
        },
        {
          title: this.$t(I18N_KEY.ORDER + 'recordTime'),
          dataIndex: 'recordTime',
          align: 'center'
        }
      ],
      FILE_TYPE: {
        'aadhaar_front': this.$t(I18N_KEY.CUSTOMER + 'aadhaarFront'),
        'aadhaar_back': this.$t(I18N_KEY.CUSTOMER + 'aadhaarBack'),
        'pan_front': this.$t(I18N_KEY.CUSTOMER + 'panFront'),
        'face_photo_list': this.$t(I18N_KEY.CUSTOMER + 'facePhotoList'),
        'card_front': this.$t(I18N_KEY.CUSTOMER + 'idcardFront'),
        'card_back': this.$t(I18N_KEY.CUSTOMER + 'idcardNegative')
      },
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 20
      }
    }
  },
  computed: {
    sendGroupList() {
      return sendGroupList
    },
    ...mapGetters('language', ['languageStorage']),
    ...mapGetters('order', [
      'orderDetail',
      'examineLogList',
      'orderDetailForCollection',
      'collectionLogList',
      'addressBookList',
      'repayRecordList',
      'orderNumberList',
      'orderImageList'
    ]),
    ...mapGetters('customer', [
      'customerDetail'
    ]),
    basicInfo() {
      return (this.customerDetail && this.customerDetail.basicInfo) || {} //在这里改
    },
    detailInfo() {
      return (this.customerDetail && this.customerDetail.detailInfo) || {}
    },
    linkmanInfos() {
      // if (this.customerDetail && this.customerDetail.linkmanInfos) {
      //   console.log('this.customerDetail', this.customerDetail.linkmanInfos)
      //   for (const argument of this.customerDetail.linkmanInfos) {
      //     console.log('加backup')
      //     argument.backup = ''
      //   }
      // }
      return (this.customerDetail && this.customerDetail.linkmanInfos) || []
    },
    aadhaarInfo() {
      return (this.customerDetail && this.customerDetail.aadhaarInfo) || {}
    },
    panInfo() {
      return (this.customerDetail && this.customerDetail.panInfo) || {}
    },
    imageInfos() {
      return (this.customerDetail && this.customerDetail.imageInfos) || []
    },
    bankCardInfo() {
      return (this.customerDetail && this.customerDetail.bankCardInfo) || []
    },
    orderInfo() {
      return (this.orderDetail || {}).orderInfo || {}
    },
    lastOrderInfo() {
      return (this.orderDetail || {}).lastOrderInfo || {}
    },
    ApprovalRecordSource() {
      return this.examineLogList || []
    },
    examineSource() {
      return this.collectionLogList || []
    },
    orderNumberSource() {
      return this.orderNumberList || []
    },
    repayRecordSource() {
      return this.repayRecordList || []
    }
  },
  mounted() {
    // console.log('换文字！！lang', lang)
    // console.log('换文字！！i18n', i18n)
    // console.log('换文字this.languageStorage -->', this.languageStorage)
    window.aa = this
    this.requestDetail(this.orderId)
    // console.log('taskid------------>', this.taskId)
    console.log('展示不展示复选框——————————————————————>', this.approvalStatus)
    if (this.approvalStatus === 2) {
      this.btndisableValue = true
      this.btndisableFBValue = true
      this.btndisableEmailValue = true
    } else {
      this.btndisableValue = false
      this.btndisableFBValue = false
      this.btndisableEmailValue = false
    }

  },
  methods: {
    ...mapActions('order', [
      'getExamineLogList',
      'getOrderDetail',
      'getOrderDetailForCollection',
      'getCollectionLogList',
      'getAddressBookList',
      'getRepayRecordList',
      'getOrderNumberList',
      'getOrderImageList'
    ]),
    ...mapActions('approval', [
      'auditApproval',
      'getApprovalListItem'
    ]),
    ...mapActions('customer', [
      'getCustomerDetail'
    ]),
    // //加密
    // encryptData() {
    //   console.log('调用了加密方法')
    //   const input = "17625931127";
    //   const aesKey = "f25b88c96a4538320c34b10b6107f73c"; // 替换为你的 AES 密钥
    //
    //   // 将密钥转换为 WordArray
    //   const key = CryptoJS.enc.Utf8.parse(aesKey);
    //
    //   // 使用 AES 加密模式 ECB 进行加密
    //   const encrypted = CryptoJS.AES.encrypt(input, key, {
    //     mode: CryptoJS.mode.ECB,
    //     padding: CryptoJS.pad.Pkcs7
    //   });
    //
    //   // 将加密后的内容转换为 Base64 字符串
    //   const encryptedBase64 = Base64.stringify(encrypted.ciphertext);
    //
    //   console.log("Encrypted Result:", encryptedBase64);
    //   this.decryptFun(encryptedBase64,aesKey)
    //
    // },
    // 解密方法
    decryptFun(encryptedBase64val, aesKeyval) {
      console.log('调用了解密的方法！')
      const encryptedBase64 = encryptedBase64val // 替换为你的加密后的数据
      const aesKey = aesKeyval // 替换为你的 AES 密钥

      // 将密钥转换为 WordArray
      const key = CryptoJS.enc.Utf8.parse(aesKey)

      // 将 Base64 字符串转换为 WordArray
      const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64)

      // 使用 AES 解密模式 ECB 进行解密
      const decrypted = CryptoJS.AES.decrypt(
        { ciphertext: encrypted },
        key,
        {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 将解密后的 WordArray 转换为字符串
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8)
      console.log('Decrypted Result:', decryptedText)
      return decryptedText
    },

    //电话备注弹框
    TextareaonRemarkChange(e) {
      console.log('电话备注栏发生变化啦！！！', e)
      console.log('电话备注栏输入的内容', e.target._value)
      // this.remarkValue += this.contactWhoType + ' ' + this.contactWhoPhone + ' ' + this.contactWhoName + ' ' + this.phoneRemarkValue
      console.log('电话备注栏输入的内容this.phoneRemarkValue--->', this.phoneRemarkValue)
    },
    TextareaonChange(e) {
      console.log('备注栏发生变化啦！！！', e)
      console.log('备注栏输入的内容', e.target._value)
      // this.remarkValue += e.target._value
      console.log('备注栏输入的内容this.remarkValue--->', this.remarkValue)
    },
    ContacthandleCancel() {
      this.ContactVisible = false
    },
    ContacthandleOk() {
      console.log(this.showFinishImg)
      if (this.showFinishImg !== 4) {
        console.log('修改联系人手机号')
        this.linkmanInfos[this.showFinishImg].backup = '已填'
      } else {
        console.log('修改本人手机号')
        this.showzhudedianhua = true
      }


      console.log('电话的备注输入框有哪些内容呢', this.phoneRemarkValue)
      console.log('this.remarkValue大的备注栏', this.remarkValue)
      console.log(' this.contactWhoType', this.contactWhoType)

      if (!this.remarkValue.includes(this.ContactVisible)) {
        console.log('执行某操作')
        this.remarkValue += this.contactWhoType + ' : ' + this.contactWhoName + ' , ' + this.contactWhoPhone + ' , ' + this.phoneRemarkValue + ' ; '

      }
      this.ContactVisible = false
    },
    openRemarkModal(typeval, nameval, phoneval, vackupval) {
      this.remarkOptions = []//清空上次选的值
      console.log('点击了备注', '联系人类型--->', typeval, '姓名--->', nameval, '电话-->', phoneval, 'backup-->', vackupval)
      console.log('vackupval', vackupval)
      this.showFinishImg = vackupval
      if (this.languageStorage == 'ti') {
        this.contactWhoType = this.$t(ContactPerson_FLAG_TI[typeval])
      } else if (this.languageStorage == 'zh-CN') {
        this.contactWhoType = this.$t(ContactPerson_FLAG[typeval])
      } else {
        this.contactWhoType = this.$t(ContactPerson_FLAG_EN[typeval])
      }


      if (typeval == '本人') {
        console.log('选择了本人加密显示！！')
        this.contactWhoPhone = phoneval.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2')
      } else {
        console.log('没选本人不加密')
        this.contactWhoPhone = phoneval
      }
      this.contactWhoName = nameval
      this.ContactVisible = true
      this.phoneRemarkValue = ''
      console.log('this.bigRemarkValue', this.bigRemarkValue)
    },
    //发送邮件
    sendEmail(val, valid) {
      const email = val
      const custId = valid
      const params = {
        email,
        custId
      }
      console.log('params', params)
      let obj = sendEmailfn(params)
      obj.then((res) => {
        if (res.code === 1000) {
          //刷新页面
          this.getCustomerDetail({ id: this.custInfoId })
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })
    },
    //编辑邮箱
    editEmail(val, id) {
      this.emailvalue = val
      this.emailEditID = id
      this.showEmialInput = !this.showEmialInput
      this.btndisableEmailValue = !this.btndisableEmailValue
      console.log('showEmialInput', this.showEmialInput)
    },
    validateEmail(email) {
      const pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      return pattern.test(email)
    },
    //取消编辑邮箱
    cancelSaveEdit() {
      this.showEmialInput = !this.showEmialInput
      this.btndisableEmailValue = !this.btndisableEmailValue
    },
    //保存邮箱
    saveEdit() {
      const email = this.emailvalue
      const id = this.emailEditID
      const params = {
        email,
        id
      }
      console.log('params', params)
      if (this.validateEmail(email)) {
        let obj = editCustomer(params)
        obj.then((res) => {
          if (res.code === 1000) {
            this.$message.success('Save successfully！')
            //刷新页面
            this.requestDetail(this.orderId)
            console.log('邮箱更新成功后刷新了页面！')
            this.showEmialInput = !this.showEmialInput
            this.btndisableEmailValue = !this.btndisableEmailValue
          } else {
            this.$message.error(res.msg)
          }
        }).finally(() => {
        })
      } else {
        this.$message.error('Mailbox format error！')
      }
    },
    //编辑facebook
    editFBEmail(val, id) {
      this.FBvalue = val
      this.FBEditID = id
      this.showFBInput = !this.showFBInput
      this.btndisableFBValue = !this.btndisableFBValue
      console.log('showFBInput', this.showFBInput)
      console.log('btndisableFBValue', this.btndisableFBValue)
    },
    //取消编辑facebook
    cancelSaveFBEdit() {
      this.showFBInput = !this.showFBInput
      this.btndisableFBValue = !this.btndisableFBValue
    },
    //保存facebook
    saveFBEdit() {
      const fb = this.FBvalue
      const id = this.FBEditID
      const params = {
        id,
        fb
      }
      console.log('params', params)
      let obj = editFacebook(params)
      obj.then((res) => {
        if (res.code === 1000) {
          this.$message.success('Save successfully！')
          //刷新页面
          this.requestDetail(this.orderId)
          console.log('FaceBook更新成功后刷新了页面！')
          this.showFBInput = !this.showFBInput
          this.btndisableFBValue = !this.btndisableFBValue
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
      })

    },
    handlePhoneClick(hrefvalue) {
      console.log('hrefvalue-->', hrefvalue)
      // document.addEventListener('error', function(e) {
      //   console.log('e', e)
      //   if (e.message.includes('Failed to launch')) {
      //     console.log('没安装')
      //   }
      // })
      // const salt = 3741 // 设置盐值
      // const encodedPhone = this.encode_phone(hrefvalue, salt) // 调用加密函数对电话号码进行加密处理
      // const encryptedHref = 'sip:' + encodedPhone // 拼接加密后的电话号码
      // console.log('encryptedHref-->', encryptedHref)
      // 调用拨打电话的操作
    },
    encode_phone(phone, salt) {
      console.log('加密拨打的电话号码', phone)
      let len = phone.toString().length
      let prefix = ''
      let suffix = 0
      let newPhone

      if (len > 8) {
        prefix = phone.toString().substr(0, len - 8)
        phone = phone.toString().substr(len - 8)
        suffix = 8 - parseInt(phone).toString().length
        phone = parseInt(phone)
      } else {
        phone = parseInt(phone)
        suffix = len - phone.toString().length
      }

      newPhone = (phone & 0xff000000)
      newPhone += (phone & 0x0000ff00) << 8
      newPhone += (phone & 0x00ff0000) >> 8
      newPhone += (phone & 0x0000000f) << 4
      newPhone += (phone & 0x000000f0) >> 4
      newPhone ^= salt

      return prefix + '' + newPhone + '' + suffix + '' + newPhone.toString().length
    },


    handleOk(e) {
      console.log(e)
      this.ModalVisible = false
    },
    pendingReviewFn() {

      let imageFlag = []
      for (const items of this.linkmanInfos) {
        if (items.backup == '') {
          imageFlag.push(0)
        } else {
          imageFlag.push(1)
        }
      }
      console.log('注册电话备注了吗', this.showzhudedianhua)
      if (this.showzhudedianhua == true) {
        imageFlag.push(1)
      } else {
        imageFlag.push(0)
      }

      console.log('点击了待复审！')
      console.log(' 要传给后端的数组imgFlags', imageFlag)
      // 证件照
      if (this.Q_cust_image_normal) {
        this.chooseItems[0].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsOne.length) {
        console.log('回显有值')
        this.chooseItems[0].itemResult = this.selectedOptionsOne
      } else {
        console.log('回显没值')
        this.chooseItems[0].itemResult = this.image_normal_array
      }

      //活动人员
      if (this.Q_cust_living_body_normal) {
        this.chooseItems[1].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsTwo.length) {
        console.log('回显有值')
        this.chooseItems[1].itemResult = this.selectedOptionsTwo
      } else {
        console.log('回显没值')
        this.chooseItems[1].itemResult = this.Q_cust_living_body_normal
      }
      //联系
      if (this.Q_cust_contactperson_normal) {
        this.chooseItems[2].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsThree.length) {
        console.log('回显有值')
        this.chooseItems[2].itemResult = this.selectedOptionsThree
      } else {
        console.log('回显没值')
        this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal
      }
      //电话
      if (this.Q_contact_phone_normal) {
        this.chooseItems[3].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFour.length) {
        console.log('回显有值')
        this.chooseItems[3].itemResult = this.selectedOptionsFour
      } else {
        console.log('回显没值')
        this.chooseItems[3].itemResult = this.Q_contact_phone_normal
      }
      console.log('最后要传给后端的数组！！！', this.chooseItems)
      // 非空校验
      if ((this.chooseItems[0].itemResult.length !== 0 && this.chooseItems[0].itemResult !== false) &&
        (this.chooseItems[1].itemResult.length !== 0 && this.chooseItems[1].itemResult !== false) &&
        (this.chooseItems[2].itemResult.length !== 0 && this.chooseItems[2].itemResult !== false) &&
        (this.chooseItems[3].itemResult.length !== 0 && this.chooseItems[3].itemResult !== false)
      ) {
        console.log('可以发请求')
        peopleExamine({
          taskId: this.taskId,
          items: this.chooseItems,
          remark: this.remarkValue,
          pendingReApprovalStatus: 1,
          imageFlag: imageFlag
        }).then((res) => {
          if (res.code === 1000) {
            this.$message.success('Submitted successfully!')
            this.$emit('closeDetail')//关闭弹窗
            this.$emit('searchQuery')//刷新页面
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.ModalVisible = true
      }

    },
    submitInfo() {
      let imageFlag = []
      for (const items of this.linkmanInfos) {
        if (items.backup == '') {
          imageFlag.push(0)
        } else {
          imageFlag.push(1)
        }
      }
      console.log('注册电话备注了吗', this.showzhudedianhua)
      if (this.showzhudedianhua == true) {
        imageFlag.push(1)
      } else {
        imageFlag.push(0)
      }
      console.log('点击了提交')
      // 证件照
      if (this.Q_cust_image_normal) {
        this.chooseItems[0].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsOne.length) {
        console.log('回显有值')
        this.chooseItems[0].itemResult = this.selectedOptionsOne
      } else {
        console.log('回显没值')
        this.chooseItems[0].itemResult = this.image_normal_array
      }

      //活动人员
      if (this.Q_cust_living_body_normal) {
        this.chooseItems[1].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsTwo.length) {
        console.log('回显有值')
        this.chooseItems[1].itemResult = this.selectedOptionsTwo
      } else {
        console.log('回显没值')
        this.chooseItems[1].itemResult = this.Q_cust_living_body_normal
      }
      //联系
      if (this.Q_cust_contactperson_normal) {
        this.chooseItems[2].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsThree.length) {
        console.log('回显有值')
        this.chooseItems[2].itemResult = this.selectedOptionsThree
      } else {
        console.log('回显没值')
        this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal
      }
      //电话
      if (this.Q_contact_phone_normal) {
        this.chooseItems[3].itemResult = [0]
        console.log('选了正常')
      } else if (this.selectedOptionsFour.length) {
        console.log('回显有值')
        this.chooseItems[3].itemResult = this.selectedOptionsFour
      } else {
        console.log('回显没值')
        this.chooseItems[3].itemResult = this.Q_contact_phone_normal
      }
      console.log('最后要传给后端的数组！！！', this.chooseItems)
      // 非空校验
      if ((this.chooseItems[0].itemResult.length !== 0 && this.chooseItems[0].itemResult !== false) &&
        (this.chooseItems[1].itemResult.length !== 0 && this.chooseItems[1].itemResult !== false) &&
        (this.chooseItems[2].itemResult.length !== 0 && this.chooseItems[2].itemResult !== false) &&
        (this.chooseItems[3].itemResult.length !== 0 && this.chooseItems[3].itemResult !== false)
      ) {
        console.log('可以发请求')
        peopleExamine({
          taskId: this.taskId,
          items: this.chooseItems,
          remark: this.remarkValue,
          pendingReApprovalStatus: 0,
          imageFlag: imageFlag
        }).then((res) => {
          if (res.code === 1000) {
            this.$message.success('Submitted successfully!')
            this.$emit('closeDetail')//关闭弹窗
            this.$emit('searchQuery')//刷新页面
          }
        }).catch(e => {
          this.$message.error(e.message)
        })
      } else {
        this.ModalVisible = true
      }

    },
    radioOneChange(e) {
      console.log('e打印出来是什么ne', e)//可以拿到正常的下标0
      console.log('可以拿到正的下标吗？', e.target.value)//可以拿到正常的下标0
      this.Q_cust_image_normal = !this.Q_cust_image_normal
    },
    radioTwoChange(e) {
      console.log('e打印出来是什么ne', e)//可以拿到正常的下标0
      console.log('可以拿到正的下标吗？', e.target.value)//可以拿到正常的下标0
      this.Q_cust_living_body_normal = !this.Q_cust_living_body_normal
    },
    radioThreeChange(e) {
      this.Q_cust_contactperson_normal = !this.Q_cust_contactperson_normal
    },
    radioFourChange(e) {
      this.Q_contact_phone_normal = !this.Q_contact_phone_normal
    },
    // normremarkCheckedFn(e) {
    //   console.log('e')
    //   this.normremarkChecked = !this.normremarkChecked
    // },
    CheckBoxOnChangeOne(checkedValues) {
      console.log('checked = ', checkedValues)
      this.image_normal_array = checkedValues
      this.childValueOne = checkedValues
      console.log('非正常情况多选的数组结果', this.image_normal_array)
    },
    CheckBoxOnChangeTwo(checkedValues) {
      this.living_body_normal_array = checkedValues
      this.childValueTwo = checkedValues
    },
    CheckBoxOnChangeThree(checkedValues) {
      this.contactperson_normal_array = checkedValues
      this.childValueThree = checkedValues
    },
    CheckBoxOnChangeFour(checkedValues) {
      this.ontact_phone_array = checkedValues
      this.childValueFour = checkedValues
    },
    rmarkboxChange(val) {
      console.log('发生变化啦', val)
      const str = val.join(',')
      console.log('回显的勾选项', str)
      this.phoneRemarkValue = str
    },
    drawContainer() {
      return document.querySelector('.ant-modal-wrap')
    },
    handelDrawer(visible) {
      if (visible) {
        this.openDrawerCount++
        this.openDrawer()
        this.openDrawerCount < 2 && this.$nextTick(() => {
          this.basicForm.setFieldsValue(this.listItem)
        })
      } else {
        this.closeDrawer()
      }
    },
    openDrawer() {
      this.visible = true
    },
    closeDrawer() {
      this.visible = false
      // this.basicForm.resetFields();
    },
    submitAuditForm(status) {
      this.basicForm.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const { remark } = values
          delete values.remark
          const items = Object.entries(values).map(item => {
            return {
              itemCode: item[0],
              itemResult: item[1]
            }
          })
          const data = {
            taskId: this.taskId,
            remark,
            items
          }
          this.auditApproval(data).then(res => {
            this.$message.success(this.$t('success'))
            this.closeParentModal()
          }).catch(e => {
            this.$message.error(e.message)
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    closeParentModal() {
      this.$emit('close')
    },
    requestDetail(id) {
      this.getExamineLogList({ orderId: id })
      this.getCollectionLogList({ orderId: id })
      this.getRepayRecordList({ orderId: id })
      this.getOrderNumberList({ orderInfoId: id })
      Promise.all([
        this.getOrderDetail({ id }),
        this.getCustomerDetail({ id: this.custInfoId }).then(res => {
          console.log('Customer Detail---》:', res.data) // 在控制台打印获取到的结果
          const jiemidata = res.data.basicInfo
          console.log('准备解密的数据', jiemidata)
          console.log('process.env.VUE_APP_JIAMI', process.env.VUE_APP_JIAMI)
          // let result = this.decryptFun(jiemidata.mobileNo, 'f25b88c96a4538320c34b10b6107f73c')
          let result = this.decryptFun(jiemidata.mobileNo, process.env.VUE_APP_JIAMI)
          jiemidata.mobileNo = result
          console.log('解密后的数据', jiemidata)
          // res.data.basicInfo.mobileNoASE = jiemidata.mobileNo.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2')//加密显示
          res.data.basicInfo.mobileNoASE = jiemidata
          console.log('jiemidata', jiemidata)
          // res.data.basicInfo.mobileNo = this.encode_phone(jiemidata.mobileNo, 3741)//加密拨打
          console.log('res.data.basicInfo.mobileNo---->', res.data.basicInfo.mobileNo)

          for (const argument of res.data.linkmanInfos) {
            console.log('加backup')
            argument.backup = ''
          }
          this.linkmanInfos = res.data.linkmanInfos
          console.log('this.link11111---', res.data.linkmanInfos)
          return res.data.basicInfo
        })
      ]).then(res => {
        this.loading = false
        this.getApprovalListItem({ taskId: this.taskId }).then(res => {
          const { remark, items } = (res && res.data) || {}
          const form = (items || []).reduce((obj, item) => {
            obj[item.itemCode] = item.itemResult
            return obj
          }, {})
          this.listItem = { remark, ...form }
          if (res.data.remark) {
            this.remarkValue = res.data.remark
          }
          console.log('回显备注的值this.remarkValue', this.remarkValue)

          console.log('有item吗？', res.data.items)
          if (res.data.items.length) {
            const EchoData = res.data.items
            // console.log('拿到要回显的数据了吗', EchoData)
            //回显打勾项目,
            const imgEchoData = JSON.parse(res.data.items[0].backup)
            console.log('拿到勾选回显了吗？', imgEchoData)
            if (imgEchoData[imgEchoData.length - 1] == 1) {// 7165638825186690049
              this.showzhudedianhua = true
            } else {
              this.showzhudedianhua = true
            }
            let newArr = imgEchoData.slice(0, 4)

            console.log('存储四个联系人的勾选数据的数组', newArr)
            console.log('this.linkmanInfos', this.linkmanInfos)
            for (let i = 0; i < newArr.length; i++) {
              console.log('newArr[i]', newArr[i])//cannot set properties of undefined (setting 'backup')

              // Object
              this.linkmanInfos[i].backup = (newArr[i] == 1 ? '已填' : '')
            }
            console.log('this.linkmanInfos', this.linkmanInfos)


            //勾选表单数据回显
            for (let i = 0; i < EchoData.length; i++) {
              if (EchoData[i].itemCode == 'Q_cust_image_normal') {
                // console.log('---------->', 1)
                this.selectedOptionsOne.push(EchoData[i].itemResult)

              }
              if (EchoData[i].itemCode == 'Q_cust_living_body_normal') {
                // console.log('---------->', 2)
                this.selectedOptionsTwo.push(EchoData[i].itemResult)

              }
              if (EchoData[i].itemCode == 'Q_cust_contactperson_normal') {
                // console.log('---------->', 3)
                this.selectedOptionsThree.push(EchoData[i].itemResult)
              }
              if (EchoData[i].itemCode == 'Q_contact_phone_normal') {
                // console.log('---------->', 4)
                this.selectedOptionsFour.push(EchoData[i].itemResult)
              }
            }
            this.selectedOptionsOne = this.selectedOptionsOne[0].split(',')
            this.selectedOptionsTwo = this.selectedOptionsTwo[0].split(',')
            this.selectedOptionsThree = this.selectedOptionsThree[0].split(',')
            this.selectedOptionsFour = this.selectedOptionsFour[0].split(',')
            if (this.selectedOptionsOne[0] === '0') {
              this.normOne = true
              this.disable0ne = true
              this.Q_cust_image_normal = !this.Q_cust_image_normal

              this.selectedOptionsOne = []

              // 证件照
              if (this.Q_cust_image_normal) {
                this.chooseItems[0].itemResult = [0]
              } else {
                this.chooseItems[0].itemResult = this.image_normal_array
              }

            } else {
              this.normOne = null
            }
            if (this.selectedOptionsTwo[0] === '0') {
              this.normTwo = true
              console.log('this.disableTwo----------', this.disableTwo)
              this.disableTwo = true
              this.Q_cust_living_body_normal = !this.Q_cust_living_body_normal
              this.chooseItems[1].itemResult = this.Q_cust_living_body_normal
              this.selectedOptionsTwo = []
              //活动人员
              if (this.Q_cust_living_body_normal) {
                this.chooseItems[1].itemResult = [0]
              } else {
                this.chooseItems[1].itemResult = this.living_body_normal_array
              }

            } else {
              this.normTwo = null
            }
            if (this.selectedOptionsThree[0] === '0') {
              this.normThree = true
              this.disableThree = true
              this.Q_cust_contactperson_normal = !this.Q_cust_contactperson_normal
              this.chooseItems[2].itemResult = this.Q_cust_contactperson_normal
              this.selectedOptionsThree = []
              //联系
              if (this.Q_cust_contactperson_normal) {
                this.chooseItems[2].itemResult = [0]
              } else {
                this.chooseItems[2].itemResult = this.contactperson_normal_array
              }

            } else {
              this.normThree = null
            }
            if (this.selectedOptionsFour[0] === '0') {
              this.normFour = '0'
              this.disableFour = true
              this.Q_contact_phone_normal = !this.Q_contact_phone_normal
              this.chooseItems[3].itemResult = this.Q_contact_phone_normal
              this.selectedOptionsFour = []
              //电话
              if (this.Q_contact_phone_normal) {
                this.chooseItems[3].itemResult = [0]
              } else {
                this.chooseItems[3].itemResult = this.ontact_phone_array
              }
            } else {
              this.normFour = null //注册电话
            }
            console.log('selectedOptionsOne', this.selectedOptionsOne)
            console.log('selectedOptionsTwo', this.selectedOptionsTwo)
            console.log('selectedOptionsThree', this.selectedOptionsThree)
            console.log('selectedOptionsFour', this.selectedOptionsFour)
            console.log('normOne', this.normOne)
            console.log('normTwo', this.normTwo)
            console.log('normThree', this.normThree)
            console.log('normFour', this.normFour)

          } else {
            console.log('没有item{{{{{{{{')
            this.normOne = false
            this.normTwo = false
            this.normThree = false
            this.normFour = false
          }

        })
      }).catch(e => {
        this.$message.error(e.message)
        this.loading = false
      })
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.addressBookIpagination.current = 1
      }
      this.addressBookLoading = true
      var params = this.getQueryParams()// 查询条件
      this.getAddressBookList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.addressBookIpagination.total = res.data.total
          this.addressBookSource = res.data.rows
        } else {
          this.addressBookIpagination.total = 0
          this.addressBookSource = []
          this.$message.error(res.msg)
        }
        this.addressBookLoading = false
      }).catch(e => {
        this.addressBookLoading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      var param = {}
      param.custId = this.custInfoId
      param.pageNum = this.addressBookIpagination.current
      param.pageSize = this.addressBookIpagination.pageSize
      return filterObj(param)
    },

    handleTableChange(pagination) {
      this.addressBookIpagination = pagination
      this.loadData()
    }
  }

}
</script>
<style lang='less' scoped>
.chose-one {
  .chose-one-item {
    height: 40px;
    font-weight: bold;
  }
}

.ant-checkbox-wrapper {
  height: 40px;
}

.ant-row {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

//.ant-col {
//  height: 40px;
//  margin-right: 10px;
//}

.tag {
  border-style: dashed;
  background: #fff;
}

.title {
  font-size: 14px;
  color: rgba(0, 0, 0, .65);
  font-weight: 400;
  margin-bottom: 12px;
}

.file-box {
  float: left;
  width: 250px;
  height: 250px;
  margin-right: 10px;
  margin: 0 8px 8px 0;

  .file-item {
    width: 100%;
    height: 100%;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    text-align: center;

    .file-preview {
      padding: 8px;
      width: 192px;
      height: 174px;
      margin-top: 16px;
    }

    .file-label {
      margin: 0;
      text-align: center;
      border-bottom: 1px solid #d9d9d9;
      padding: 8px;
      font-weight: 500;
      font-size: 16px;
    }
  }
}

.setting-drawer-handle {
  position: fixed;
  top: 240px;
  background: #1890ff;
  width: 32px;
  height: 32px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1301;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;
  transition: transform 0.3s cubic-bezier(0.9, 0, 0.3, 0.7);

  &.active {
    transform: translateX(-600px);
    // right: 500px;
  }

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }
}

.audit-form {
  width: 100%;
  padding: 10px;
  border: 1px solid #e9e9e9;
  background: #fff;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

/deep/ .description-list .content {
  font-weight: 700;
}
</style>